import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';


import { Link as RouterLink } from 'react-router-dom';

import {
    Button,
    Card,
    CardContent,
    CardHeader, Divider, Grid,
    IconButton, Link, Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip,
    Typography
} from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';

import { NavContext, NavRoutes } from "../../../contexts";
import { ContattoContext } from '../ContattoContext';

const LinkRouter = props => <Link {...props} component={RouterLink} />;

export const ContattiList = ({
    disabled,
    onActionClick,
    ...props }) => {

    const {
        getRouteTo,
        navigateTo,
    } = useContext(NavContext);

    const {
        state,
        setState,
    } = useContext(ContattoContext);

    const {
        contatti,
    } = state;

    const {
        ufficioId,
        contattoId,
    } = useParams();

    const deleteClickHandler = async (data) => {
        if (onActionClick)
            onActionClick("Delete", data);
    }

    const addClickHandler = async (data) => {
        if (onActionClick)
            onActionClick("Add", data);
    }

    return (
        <>
            <Grid container spacing={2} sx={{ marginTop: 2 }}>
                <Grid item xs={12}>
                    <Card>
                        <CardHeader
                            sx={{
                                color: "white",
                                backgroundColor: "secondary.main",
                            }}
                            title={
                                <Grid container alignItems="center" justifyContent="space-between">
                                    <Grid item>
                                        <Typography variant="h6">Attributi</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            variant="contained"
                                            disableElevation
                                            color="info"
                                            disabled={disabled}
                                            onClick={addClickHandler}
                                        >
                                            Aggiungi
                                        </Button>
                                    </Grid>
                                </Grid>
                            }
                        />
                        <Divider />
                        <CardContent sx={{ padding: "0px !important" }}>
                            <Table>
                                <TableHead sx={{
                                    backgroundColor: "aliceblue",
                                }}>
                                    <TableRow>
                                        <TableCell style={{ width: "50%" }}>TIPO</TableCell>
                                        <TableCell align="right"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        contatti && contatti.result.length > 0 ?
                                            contatti.result?.map((contatto, index) => <TableRow key={index}>
                                                <TableCell style={{ width: "100%" }}>
                                                    <div sx={{
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                        <LinkRouter
                                                            color="textPrimary"
                                                            to={getRouteTo(NavRoutes.Contatto, [ufficioId, contatto.id])}
                                                            sx={{ fontWeight: 700, }}>
                                                            {contatto.descrizione}
                                                        </LinkRouter>
                                                    </div>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <IconButton
                                                        aria-label="delete"
                                                        disabled={disabled}
                                                        onClick={() => deleteClickHandler(contatto)}>
                                                        <Tooltip title="elimina attributo">
                                                            <DeleteIcon />
                                                        </Tooltip>
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>)
                                            :
                                            <TableRow>
                                                <TableCell align="center" colSpan="100%" sx={{ padding: 8, color: "primary.main", fontWeight: "bold" }}>
                                                    NON SONO PRESENTI ATTRIBUTI
                                                </TableCell>
                                            </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </>
    );
}